import { useMemo, useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useReporters } from '@/queries/tickets'
import { Input } from '@/components/ui/input'
import { FullPageSpinner } from '@/components/etainabl-spinner'

export function ReporterPicker() {
  const { data, isLoading } = useReporters()
  const [term, setTerm] = useState('')
  const navigate = useNavigate()

  const rows = useMemo(() => {
    const t = term.trim().toLowerCase()
    if (!t) return data ?? []
    return (data ?? []).filter(r =>
      r.name.toLowerCase().includes(t) || r.email.toLowerCase().includes(t) || r.companyName.toLowerCase().includes(t)
    )
  }, [data, term])

  if (isLoading) return <FullPageSpinner srLabel="Loading reporters" />

  return (
    <div className="mx-auto max-w-2xl p-6">
      <h1 className="mb-1 text-lg font-semibold">View as user</h1>
      <p className="mb-4 text-sm text-muted-foreground">
        Open a reporter&apos;s inbox exactly as they see it. Read-only — replies you send are still from you.
      </p>
      <Input
        value={term}
        onChange={e => setTerm(e.target.value)}
        placeholder="Filter by name, email or company…"
        className="mb-4"
      />
      <ul className="divide-y divide-border rounded-md border border-border">
        {rows.map(r => (
          <li key={r._id}>
            <button
              type="button"
              className="flex w-full items-center justify-between px-4 py-3 text-left hover:bg-muted"
              onClick={() => navigate({ to: '/tickets', search: { asUser: r._id } as never })}
            >
              <span>
                <span className="block text-sm font-medium">{r.name || r.email}</span>
                <span className="block text-xs text-muted-foreground">{r.email}</span>
              </span>
              <span className="text-xs text-muted-foreground">{r.companyName}</span>
            </button>
          </li>
        ))}
        {!rows.length && (
          <li className="px-4 py-6 text-center text-sm text-muted-foreground">No reporters match that filter.</li>
        )}
      </ul>
    </div>
  )
}
